<template>
  <div>
    <template v-if="$route.path === '/bulk'" >
      <BulkUploadForm />
    </template>
    <template v-if="$route.path === '/bulk/review'" >
      <ReviewBulkUpload />
    </template>
    <template v-if="$route.path === '/bulk/payment'" >
      <BulkPayment />
    </template>
  </div>
</template>

<script>
  import BulkUploadForm from '../../components/Forms/BulkUploadForm'
  import ReviewBulkUpload from './ReviewBulkUpload'
  import BulkPayment from './BulkPayment'

  export default {
    name: 'BulkUpload',
    components: {
      BulkUploadForm,
      ReviewBulkUpload,
      BulkPayment
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/Pages/BulkUpload/BulkUpload.vue?6af62842